export enum StreamType {
  Main = "MAIN",
  Trial = "TRIAL",
}
